import { NetInfoState } from '@react-native-community/netinfo';
import { atom } from 'jotai';

import { ShowToastProps } from '@/hooks/useToaster';

export const isOnlineAtom = atom<NetInfoState['isConnected']>(false);

export const showWarningToastAtom = atom<((props: ShowToastProps) => void) | undefined>(undefined);
